<template>
	<div>
		<div class="nTop" id="toTop" style="background-color:#FFF;">
		  <div class="wrapper clearfix">
		    <a class="logo">
		      <img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司" />
		      <h1>佰吉宏安国际能源有限公司</h1>
		    </a>
		    <a class="nt-link" @click="yanzheng('/main')">
		      <img src="../../assets/images/ico01.png" />
		      <span>个人中心</span>
		    </a>
		  </div>
		</div>
		
		<div class="header">
		  <div class="wrapper clearfix">
		    <div class="nav clearfix">
		      <!-- <router-link  to="/about">关于我们</router-link> -->
		      <a @click="tabIndex(1, '/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
		      <a @click="tabIndex(2, '/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
		      <a @click="tabIndex(3, '/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
		      <a @click="tabIndex(6, '/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
		    </div>
		    <div class="dl-an clearfix" v-if="isLogin">
		      <a @click="toPage('/login')">
		        <img src="../../assets/images/ico02.png" />
		        <span>登录</span>
		      </a>
		      <a @click="toPage('/register')">
		        <img src="../../assets/images/ico03.png" />
		        <span>注册</span>
		      </a>
		    </div>
		  </div>
		</div>
		
		
		
		<!-- banner -->
		<div class="banner">
		    <el-carousel @change="bannerLoop" indicator-position="none" :height="bannerHeight">
		        <el-carousel-item v-for="(item, index) in banner" :key="index"><img style="height: 100%;" ref="imageUrl" :src="item.image_uri" alt="" /></el-carousel-item>
		    </el-carousel>
		    <div class="banner-num">
		        <div style="font-size: 30px;color: #ff1400;">0{{ bannerIndex }}</div>
		        <div class="line"></div>
		        <div style="font-size: 18px;" v-if="banner">0{{ banner.length }}</div>
		    </div>
		</div>
		<!-- 面包屑 -->
		<div class="crumbs" style="background-color: #f5f5f5;">
			<div class="n-wrapper clearfix">
				<h3 class="colsName">主营产品</h3>
				<div class="m-crumb">
					您当前的位置：<a href=""><router-link  to="/home">首页</router-link></a> <i>></i> <span>主营产品</span>
				</div>
			</div>
		</div>
		
		<div class="n-out" style="background-color: #fff;">
			<div class="n-wrapper">
				
				<h3 class="titBox"><span>product</span> <small>主营产品</small></h3>
		
		        <div class="colsNav flexbox11 flexwarp" v-if="category_list.length>1">
		            <a @click="tabIndex1(item.id,index)" :class="keyIndex1 == index ? 'active' : ''" v-for="(item,index) in category_list" :key='index'>{{item.name}}</a>
		        </div>
				
				<div class="product clearfix">
					<div class="list" v-for="(item,index) in list" :key="index" @click="openPage(item)">
						<a>
							<img :src="item.image_uri" alt="" class="img">
							<div class="cont">
								<em></em>
								<p style="text-align:left" :class="item.is_content == 1 ? 'arrow' : ''" class="tit txthide">{{item.name}}</p>
							</div>
						</a>
					</div>
				</div>
				<!-- 此处放分页 -->
				<div class="elPage">
				 <el-pagination
				   background
				   :page-size="8"
				   @current-change="change"
				   @prev-click="prev()"
				   @next-click="next()"
				   layout="prev, pager, next"
				   :total="this.list.length">
				 </el-pagination>
				</div>
			</div>
		</div>
		<div class="footer">
		  <div class="wrapper">
		    <div class="f-nav">
		      <a @click="tabIndex(1, '/home')">首页</a>
		      <a @click="tabIndex(2, '/about')">关于我们</a>
		      <a @click="tabIndex(3, '/honor')">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')">招标信息</a>
		      <a @click="tabIndex(6, '/partner')">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')">联系我们</a>
		    </div>
		
		    <div class="f-box flexbox">
		      <img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot" />
		      <div class="f-center flexbox33 flexwarp" style="text-align: left;">
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico05.png" />
		          <p>联系电话：{{ footerMassage.mobile }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico06.png" />
		          <p>邮政编码：{{ footerMassage.postal }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico07.png" />
		          <p>访问量：{{ footerMassage.pageviews }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico08.png" />
		          <p>电子邮箱：{{ footerMassage.email }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico09.png" />
		          <p>公司地址：{{ footerMassage.address }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico10.png" />
		          <p>交易量：{{ footerMassage.trading_volume }}</p>
		        </div>
		      </div>
		      <div class="qrcode">
		        <img :src="footerMassage.image_id5_url" alt="" />
		        <p>扫一扫了解更多</p>
		      </div>
		    </div>
		    <div class="copyright">
		      Copyright 2021 ·版权所有 佰吉宏安国际能源有限公司
		      <a href="https://beian.miit.gov.cn" target="_blank">{{ footerMassage.site_icp }}&nbsp;{{ footerMassage.site_wabah }}</a>
		      <br />
		      建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
		    </div>
		  </div>
		</div>
		<!-- 右侧浮动 -->
		<div class="floatWindow">
		    <div class="item" @click="toPage('/announcement')">
		        <a class="ico"><img src="../../assets/images/a01.png"></a>
		        <p class="txt">公告</p>
		    </div>
		    <div class="item" @click="yanzheng('/main_news')">
				<div class="index_dot" v-if="isRed">
					
				</div>
		        <a class="ico"><img src="../../assets/images/a02.png"></a>
		        <p class="txt">消息</p>
		    </div>
			<div class="item"  @click="toPage('/bidding')">
			    <a class="ico"><img src="../../assets/images/a03.png"></a>
			    <p class="txt">竞拍</p>
			</div>
			<div class="item">
			    <a class="ico"><img src="../../assets/images/a04.png"></a>
			    <p class="txt">{{footerMassage.mobile}}</p>
			</div>
			<div class="item"  @click="toPage('/contact')">
			    <a class="ico"><img src="../../assets/images/a05.png"></a>
			    <p class="txt">{{footerMassage.address}}</p>
			</div>
		    <!-- <div class="item">
		        <a href="" target="_blank" class="ico"><img src=""></a>
		    </div> -->
		   <div class="item">
				<a class="ico Top" href="#toTop"><img src="../../assets/images/a06.png"></a>
			</div>
		</div>
	</div>
	
</template>

<script>
	import Utils from '../../utils/utils.js';
	export default {
	    name: 'product',
	    data() {
	        return {
				keyIndex1:0,
	            list:[],
				category_list:[],
				page:1,
				count:0,
				category_id:'',
				banner: '',
				bannerIndex: 1,
				bannerHeight: '435px',
				
				keyIndex:4,
				isLogin: true,
				footerMassage:'',
				isRed:false,
	        };
	    },
	    mounted() {
	        this.getList()
			this.getBanner();
			//增加浏览量
			this.pageviews();
			
			this.site_info()
			this.getRed()
			 var that = this;
			Utils.$on('getRed', function (msg) {
				that.getRed();
			})
	    },
	    methods: {
			async getRed() {
				var _this = this
				if(!this.$getStorage('userToken')) return
			    let { status, message, data } = await this.$ajax('no_read_information', {
					userToken: this.$getStorage('userToken'),
			    });
			    if (status == this.SUCCESS_CODE) {
						if(data == 0){
							_this.isRed = false
						}else{
							_this.isRed = true
						}
			    } else {
			        this.$message(message);
			    }
			},
			toPage(pathName, title){
				this.$router.push({
					path: pathName,
					query: { pageTitle: title }
				});
			},
			//底部导航信息
			async site_info(idnex) {
			  this.timeIndex = idnex;
			  if (this.$getStorage('userToken')) {
			    this.isLogin = false;
			  } else {
			    this.isLogin = true;
			  }
			  let { status, message, data } = await this.$ajax('site_info', {});
			  if (status == this.SUCCESS_CODE) {
			    this.footerMassage = data;
			  } else {
			    this.$message(message);
			  }
			},
			yanzheng(str) {
			  var _this = this;
			  if (this.$getStorage('userToken')) {
			    _this.toPage(str);
			  } else {
			    _this.$message({
			      message: '请先登录',
			      type: 'warning'
			    });
			    _this.toPage('/login');
			  }
			},
			tabIndex(index,str){
				// this.keyIndex = index
				// window.sessionStorage.setItem('keyIndex', index);
				// this.$setStorage('lastKeyIndex',index)
				// this.$setStorage('keyIndex',index)
				
				this.$router.push({
					path: str
				});
			},
			bannerLoop(index) {
			    this.bannerIndex = index + 1;
			},
			//获取轮播图
			async getBanner(idnex) {
			    this.timeIndex = idnex;
			    let { status, message, data } = await this.$ajax('banner', {
			        type: 2 //1 首页banner 2 内容页头部banner
			    });
			    if (status === this.SUCCESS_CODE) {
			        this.banner = data;
			        let _this = this;
			        _this.$nextTick(function() {
			            setTimeout(function() {
			                _this.bannerHeight = _this.$refs['imageUrl'][0].offsetHeight + 'px';
			            }, 300);
			        });
			    } else {
			        this.$message(message);
			    }
			},
			//增加浏览量
			async pageviews(idnex) {
			    let { status, message, data } = await this.$ajax('pageviews', {});
			    if (status === this.SUCCESS_CODE) {
			    } else {
			        // this.$message(message);
			    }
			},
			openPage(item){
				var that = this
				console.log(item)
				if(item.is_content == 1){
					that.$router.push({
						path: '/productDetail',
						query: {id:item.id}
					});
				}
			},
			tabIndex1(id,index){
				this.category_id = id
				this.keyIndex1 = index
				this.page = 1
				this.getList()
			},
			change(e){
				this.page = e
				this.getList()
			},
			prev(e){
				this.page = this.page - 1
				this.getList()
			},
			next(e){
				this.page = this.page + 1
				this.getList()
			},
	        async getList() {
	            let { status, message, data } = await this.$ajax('porjects_list', {
					page:this.page,
					limit:8,
					category_id:this.category_id
				});
	            if (status == this.SUCCESS_CODE) {
					this.count = data.count
					this.category_list = data.category_list
					this.list = data.list
	            } else {
	                this.$message(message);
	            }
	        },
	      
		}
	};
</script>

<style>
	@import '../../assets/swiper-bundle.min.css';
	.arrow{
		  background: url(../../assets/images/ico11.png) right center no-repeat;
	}
	.banner-num {
	    display: flex;
	    position: absolute;
	    left: 160px;
	    bottom: 88px;
	    color: #fff;
	    z-index: 9999;
	    align-items: center;
	}
	/* 主营产品 */
	.product .list{width: 23.5%;height: 402px;float: left;margin: 0 2% 30px 0;position: relative;}
	.product .list:nth-child(4n){margin-right: 0;}
	.product .list a{display: block;width: 100%;height: 100%;}
	.product .list .img{display: block;width: 100%;min-height: 100%;}
	.product .list .cont{background: rgba(0,0,0,.6);position: absolute;left: 0;right: 0;bottom: 0;height: 105px;color: #fff;padding: 30px 20px 0;transition: .5s;}
	.product .list em{display: block;width: 35px;height: 2px;background: #ffcfb0;margin-bottom: 15px;}
	.product .list .tit{font-size: 20px;line-height: 30px;}
	.product .list:hover .cont{background: rgba(126,10,0,.6);}
	.elPage{
		width: 100%;
		margin-top: 20px;
	} 
	
	.elPage .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #8a0d02;
	} 
	.elPage .el-pagination.is-background .el-pager li:not(.disabled):hover{
		color: #8a0d02;
	}
	.elPage .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
		color: #fff ;
	} 
	.index_dot{
		width: 10px;
		height: 10px;
		position: absolute;
		right: 5px;
		top: 5px;
		border-radius: 50%;
		background-color: #af2f24;
	}
</style>



// WEBPACK FOOTER //
// src/views/product/product.vue